import React from "react";
import { SvgIcon } from "@mui/material";

/** Stroke-based social glyphs that match Outlined MUI tab icons. */
const strokeProps = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export function LinkedInOutlineIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <rect x="4" y="4" width="16" height="16" rx="2" {...strokeProps} />
      <path d="M8 11v6M8 8.5v.01M12 17v-4.5a2 2 0 0 1 4 0V17" {...strokeProps} />
    </SvgIcon>
  );
}

export function FacebookOutlineIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M14 9h3V6h-3c-2.2 0-4 1.8-4 4v2H8v3h2v6h3v-6h2.5l.5-3H13v-1.5c0-.8.2-1.5 1-1.5z"
        {...strokeProps}
      />
    </SvgIcon>
  );
}

export function XOutlineIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M6 6l12 12M18 6L6 18" {...strokeProps} />
    </SvgIcon>
  );
}

export function InstagramOutlineIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <rect x="4" y="4" width="16" height="16" rx="4" {...strokeProps} />
      <circle cx="12" cy="12" r="3.5" {...strokeProps} />
      <circle cx="16.5" cy="7.5" r="0.6" fill="currentColor" stroke="none" />
    </SvgIcon>
  );
}
